import {useToast} from "@shopify/app-bridge-react";
import {useCallback, useState} from "react";
import Api from "../../../helpers/api";
import {
    Button,
    Modal,
    DropZone,
    FormLayout,
    LegacyStack,
    Text,
} from "@shopify/polaris";
import ImportsList from "./ImportsList";

export default ({
    loading = false,
    setLoading = () => {},
    productType = null,
}) => {
    const toast = useToast();
    const [internalLoading, setInternalLoading] = useState(false);
    const [modalActive, setModalActive] = useState(false);
    const [file, setFile] = useState(null);
    const [listReload, setListReload] = useState(0);

    const onClose = () => {
        setFile(null);
        setModalActive(false);
    };

    const loadImports = useCallback(() => {
        setListReload(prev => prev + 1);
    }, []);

    const importInventory = useCallback(() => {
        if (!file) {
            toast.show("You need to upload file");
            return;
        }
        if (!productType?.value) {
            toast.show("Product type is missing");
            return;
        }

        setLoading(true);
        setInternalLoading(true);

        Api.importInventory({
            file: file,
            type: 'b2b_pricing',
            products_type: productType.value,
        })
            .then(() => {
                toast.show("Specials Import has been started");
                setFile(null);
                loadImports();
            })
            .catch(() => {
                toast.show("Server error. Please try again");
            })
            .finally(() => {
                setLoading(false);
                setInternalLoading(false);
            });
    }, [file, productType]);

    const handleDropZoneDrop = useCallback(
        (_dropFiles, acceptedFiles) => setFile(acceptedFiles[0]),
        [],
    );

    const fileUpload = !file && <DropZone.FileUpload />;
    const uploadedFile = file && (
        <LegacyStack distribution="center" alignment="center">
            <div>
                {file.name}{' '}
                <Text variant="bodySm" as="p">
                    {file.size} bytes
                </Text>
            </div>
        </LegacyStack>
    );

    const downloadCsvSample = useCallback(() => {
        const header = productType?.value === 'furnace'
            ? [
                'IT Enable','Sku','"Concatenate with E, then delete"',
                '"Temp Item Description Copy to M, then delete"',
                '"Temp Price Copy to I, then delete"','SIZE','nm',
                'retail_price','ds','qty_available','special_price',
            ]
            : [
                'IT Enable','opt1','Sku','SIZE','nm','retail_price','status',
                'Opt2','product Line','ds','BinLocation','product_categories_vir',
                'products_vir','searchfield1','Seachfield5','featured',
                'parent_child_type','managed inventory','qty_avail','qty_add',
                '"phantom inventory(husbandry)"','"Exports/Orders"','special_price',
                'Quantity Increment','Minimum Order Quantity','Maximum Order Quantity',
                'Quantity Break 1','Price Break 1','Quantity Break 2','Price Break 2',
                'Quantity Break 3','Price Break 3','Quantity Break 4','Price Break 4',
                'Quantity Break 5','Price Break 5','Quantity Break 6','Price Break 6',
                'Quantity Break 7','Price Break 7','Quantity Break 8','Price Break 8',
                'Quantity Break 9','Price Break 9','Quantity Break 10','Price Break 10'
            ];

        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(header.join(',')));
        element.setAttribute('download', 'sample.csv');
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }, [productType]);

    return (
        <Modal
            open={modalActive}
            title={`${productType.label} - Import Specials with CSV`}
            activator={
                <Button
                    variant="primary"
                    loading={internalLoading}
                    disabled={loading && !internalLoading}
                    onClick={() => setModalActive(true)}
                >
                    Import Specials
                </Button>
            }
            onClose={onClose}
            secondaryActions={[
                { content: "Close", onAction: onClose },
                { content: "CSV Sample", onAction: downloadCsvSample },
            ]}
            size="large"
        >
            <Modal.Section>
                <FormLayout>
                    <DropZone allowMultiple={false} onDrop={handleDropZoneDrop} accept="text/csv">
                        {uploadedFile}
                        {fileUpload}
                    </DropZone>
                </FormLayout>
                <LegacyStack>
                    <Button
                        variant="primary"
                        disabled={loading && !internalLoading}
                        loading={internalLoading}
                        onClick={importInventory}
                    >
                        Import
                    </Button>
                </LegacyStack>
            </Modal.Section>
            <Modal.Section>
                <ImportsList type="b2b_pricing" loading={loading} listReload={listReload} products_type={productType.value} />
            </Modal.Section>
        </Modal>
    );
};
